<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 overflow-y-auto overflow-x-hidden no-scroll-bar background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="height-100px row p-0 m-0 background-primary-blue w-100 border-bottom border-dark-subtle p-3 z-max d-flex justify-content-center align-items-center">
        <div (click)="back()" class="col-2 pt-4 pb-4 btn text-reset d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-chevron-left fa-xl p-3"></i>
        </div>
        <div class="col-8">
            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-auto fs-main text-center color-white">Alter {{ paddock()?.name }}</div>
            </div>
        </div>
        <div (click)="close()" class="pointer text-reset col-2 d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-x fa-xl"></i>
        </div>
    </div>
    <div class="d-flex flex-column gap-3 p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        <div>
            <div class="h5">Name</div>
            <div>
                <input (input)="setName($event.target.value)"
                    [disabled]="loading() || !userStore.canEdit()"
                    class="form-control"
                    datatype="text"
                    id="name"
                    name="name"
                    placeholder="Name"
                    type="text"
                    value="{{ paddock()?.name }}">
            </div>
        </div>
        <app-generic-button
            (click)="applyChanges()"
            description="Apply changes to proximity-sample point"
            [alwaysShowText]="true"
            [buttonText]="'Apply changes'"
            [disabled]="loading() || !userStore.canEdit()"
            [loading]="loading()"
            [primaryIcon]="'fa-solid fa-check'"/>
        <app-generic-button
            (click)="delete()"
            description="Delete paddock"
            [alwaysShowText]="true"
            [buttonClass]="'btn-danger btn-danger-shadow'"
            [buttonText]="'Delete paddock'"
            [disabled]="loading() || !userStore.canEdit()"
            [loading]="loading()"
            [primaryIcon]="'fa-solid fa-trash-can'"/>
    </div>
</div>
